module.exports = __webpack_public_path__ + "static/media/festival-virtual-da-gaita-ponto.d863b120.jpg";